<template>
  <BaseContainer>
    <SkeletonLoader class="w-full h-8 mb-6" />
    <SkeletonLoader class="w-10/12 h-4 mb-2" />
    <SkeletonLoader class="w-11/12 h-4 mb-2" />
    <SkeletonLoader class="w-11/12 h-4 mb-2" />
    <SkeletonLoader class="w-10/12 h-4 mb-2" />
    <SkeletonLoader class="w-9/12 h-4" />
  </BaseContainer>
</template>

<script setup>
import BaseContainer from '@/components/layout/base/BaseContainer.vue'
import SkeletonLoader from '@/components/layout/base/SkeletonLoader.vue'
</script>
